import React from "react";
import PowertrainLights from "../../SpotLight";
const Interior = React.lazy(() => import("../Interior/Interior"));
import TunnelContainer from "../Tunnel/TunnelContainer";
import SuspensionContainer from "./SuspensionContainer";
// import Interior from "../Interior/Interior";

const OrbitMode = () => {
  return (
    <>
      <Interior />
      <TunnelContainer />
      <PowertrainLights />
      <SuspensionContainer />
    </>
  );
};

export default OrbitMode;
